/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"

import Navbar from "./navbar"
import { PageContextProvider } from "../hooks/use-page-context"
import "../../bulma.scss"
import "./layout.css"

require("../../fonts/index.css")

const Layout = ({ pageContext, children, footer }) => (
  <PageContextProvider value={pageContext}>
    <Navbar />
    <main>{children}</main>
    {footer}
  </PageContextProvider>
)

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
